import axiosInstance from "../../utils/AxiosInstance";
import { toast } from "react-toastify";
import { useAuthHeader } from "react-auth-kit";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useGetPatients } from "../PatientComponents";
import { toastError, toastSuccess } from "../../utils/utils";

// GET /smartboxes
export const useGetSmartboxes = () => {
  const authHeader = useAuthHeader();

  return useQuery({
    queryKey: ["smartboxes"],
    queryFn: async () => {
      const res = await axiosInstance.get(`/smartboxes`, {
        headers: { Authorization: authHeader() },
      });
      return res.data;
    },
  });
};

// GET /smartboxes/:smartbox_id
export const useGetSmartboxById = (smartbox_id) => {
  const authHeader = useAuthHeader();

  return useQuery({
    queryKey: ["smartboxes", smartbox_id],
    queryFn: async () => {
      const res = await axiosInstance.get(`/smartboxes/${smartbox_id}`, {
        headers: { Authorization: authHeader() },
      });
      return res.data;
    },
    enabled: smartbox_id !== undefined && smartbox_id !== null,
  });
};

// === PUT /smartboxes/:smartbox_id ===
export const usePutSmartboxById = (smartbox_id, closeModal) => {
  const authHeader = useAuthHeader();
  const queryClient = useQueryClient();
  const getOriginalData = useGetSmartboxById(smartbox_id);

  return useMutation({
    mutationFn: async (editedSmartbox) => {
      if (editedSmartbox === undefined) return;
      const smartbox_id = editedSmartbox.id;
      const res = await axiosInstance.put(
        `/smartboxes/${smartbox_id}`,
        editedSmartbox,
        {
          headers: { Authorization: authHeader() },
        }
      );
      return res.data;
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(["smartboxes"]); // update views inside Doctors page
      queryClient.invalidateQueries(["smartboxes", variables.id]); // update views inside ViewDoctor
      toast.success("Dettagli smartbox aggiornati!", toastSuccess);
      closeModal();
    },
    onError: (data, variables, context) => {
      let newData =
        smartbox_id === null
          ? queryClient.getQueryData(["smartboxes", variables.id])
          : getOriginalData.data;
      queryClient.setQueryData(["smartboxes", smartbox_id], (oldData) => {
        return {
          ...oldData,
          ...newData,
        };
      });
      toast.error("Dettagli smartbox non aggiornati", toastError);
    },
  });
};

// === POST /smartboxes ===
export const useNewSmartbox = (closeModal) => {
  const authHeader = useAuthHeader();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (newSmartbox) => {
      const res = await axiosInstance.post(`/smartboxes`, newSmartbox, {
        headers: {
          Authorization: authHeader(),
        },
      });
      return res.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(["smartboxes"]);
      toast.success("Smartbox aggiunta con successo!", toastSuccess);
      closeModal();
    },
    onError: (error) => {
      const errorMessage =
        error?.response?.data?.error || "Errore nell'aggiunta della smartbox";
      toast.error(errorMessage, toastError);
    },
  });
};
